// Read-side poll shape on a BtSlimMessage. Engines project their raw
// form — WAWeb `Msg.poll = {question, options[{name}]}` for chrome,
// the baileys poll-creation message for baileys — to this slim shape
// at the handler boundary. The raw WAWeb poll shape lives inside the
// chrome extension per #74.
//
// NOT the same as `BtUserMessagePoll` (lives in schemas/bt/user-message.ts):
// that's the WRITE-side / persisted shape with `{id, text, order}` per
// option for vote tracking + render order. This slim form is read-only.

import { z } from 'zod';

export const BtSlimPollOptionSchema = z.object({
  text: z.string().optional(),
});
export type BtSlimPollOption = z.infer<typeof BtSlimPollOptionSchema>;

export const BtSlimPollSchema = z.object({
  question: z.string().optional(),
  options: z.array(BtSlimPollOptionSchema).optional(),
});
export type BtSlimPoll = z.infer<typeof BtSlimPollSchema>;
